module.exports = __webpack_public_path__ + "static/media/CaRi-Heart interpretation guide_1384.baecaf1c.pdf";